import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

// Theme: 'light' | 'dark'
// Persisted in localStorage under `fos_theme`. Toggles the `<html class="dark">` flag.
const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

function readInitial() {
  try {
    const saved = localStorage.getItem("fos_theme");
    if (saved === "light" || saved === "dark") return saved;
  } catch (e) { /* ignore */ }
  return "light";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitial());

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    try { localStorage.setItem("fos_theme", theme); } catch (e) { /* ignore */ }
  }, [theme]);

  const toggleTheme = useCallback(() => setTheme((t) => (t === "light" ? "dark" : "light")), []);

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}
